import { injectable } from "tsyringe";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { IPackageLookupRepository } from "../repositories/IPackageLookupRepository";
import { PackageLookupRequestEntity } from "../entities/PackageLookupRequestEntity";
import { PackageLookupResponseEntity } from "../entities/PackageLookupResponseEntity";
import { PackageLookupInjection } from "features/packageLookup/di/PackageLookupInjection";

@injectable()
export class PackageLookupUseCase {
  private repo: IPackageLookupRepository;

  constructor() {
    this.repo = PackageLookupInjection.getRepo();
  }

  async viewPlan(
    params: PackageLookupRequestEntity
  ): Promise<BaseApiResponseModel<PackageLookupResponseEntity>> {
    return this.repo.viewPlan(params);
  }
}
